module.exports = __webpack_public_path__ + "static/img/SC.a29fa7fe.svg";